// src/routes/AppRoutes.jsx
import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import PublicPage from '../pages/PublicPage';
import { trackSpaRoute } from '../analytics/hotjar';

export default function AppRoutes() {
  const loc = useLocation();

  useEffect(() => {
    if (import.meta.env.PROD) trackSpaRoute(loc.pathname + loc.search);
  }, [loc]);

  return (
    <Routes>
      <Route path="/:username" element={<PublicPage />} />
      <Route path="*" element={<PublicPage />} />
    </Routes>
  );
}
